"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useImage = _interopRequireDefault(require("use-image"));

var _photoContext = require("../photo-context");

var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _konva = _interopRequireDefault(require("konva"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ProgressRingContainer = _styledComponents.default.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ImageContainer = _styledComponents.default.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const getScale = (height, width, containerHeight, containerWidth) => {
  let interScale;

  if (height >= width) {
    interScale = containerHeight / height;
  } else {
    interScale = containerWidth / width;
  }

  if (height * interScale >= containerHeight) {
    interScale = containerHeight / height;
  } else if (width * interScale >= containerWidth) {
    interScale = containerWidth / width;
  }

  return interScale;
};

const EditableImage = ({
  src,
  onLoad,
  onError
}) => {
  var _imageRef$current;

  const [image, status] = (0, _useImage.default)(src, "anonymous");
  const {
    state: photoState,
    handlers: photoHandlers
  } = (0, _photoContext.usePhoto)();
  const containerRef = (0, _react.useRef)(null);
  const imageRef = (0, _react.useRef)(null);
  const imageLayerRef = (0, _react.useRef)(null);
  const stageRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (containerRef.current) {
      photoHandlers.setDimensions({
        height: containerRef.current.offsetHeight,
        width: containerRef.current.offsetWidth
      });
    }
  }, [containerRef.current, image, status]);

  const scrollZoom = e => {
    if (imageLayerRef.current && stageRef.current && e.evt.wheelDeltaY) {
      var _imageLayerRef$curren;

      const newScale = e.evt.wheelDeltaY > 0 ? _photoContext.SCROLL_INCREMENT : -_photoContext.SCROLL_INCREMENT;
      photoHandlers.setZoom((((_imageLayerRef$curren = imageLayerRef.current.attrs) === null || _imageLayerRef$curren === void 0 ? void 0 : _imageLayerRef$curren.scaleY) || _photoContext.DEFAULT_ZOOM_SCALE) + newScale);
    }
  };

  const pointer = () => {
    document.body.style.cursor = "grab";
  };

  const cursor = () => {
    document.body.style.cursor = "default";
  };

  (0, _react.useEffect)(() => {
    if (imageLayerRef.current && photoState.dimensions.height && photoState.dimensions.width) {
      imageLayerRef.current.offsetX(imageRef.current.width() / 2);
      imageLayerRef.current.offsetY(imageRef.current.height() / 2);
      imageLayerRef.current.setAttrs({
        x: photoState.dimensions.width / 2,
        y: photoState.dimensions.height / 2
      });
      stageRef.current.setAttrs({
        width: photoState.dimensions.width,
        height: photoState.dimensions.height
      });
    }
  }, [imageRef.current, imageLayerRef.current, photoState.dimensions.height, photoState.dimensions.width, imageRef === null || imageRef === void 0 ? void 0 : (_imageRef$current = imageRef.current) === null || _imageRef$current === void 0 ? void 0 : _imageRef$current.naturalWidth, status]);
  (0, _react.useEffect)(() => {
    if (status == "loaded") {
      onLoad && onLoad();
      stageRef.current = new _konva.default.Stage({
        container: "container"
      });
      imageLayerRef.current = new _konva.default.Layer();
      stageRef.current.add(imageLayerRef.current);
      imageRef.current = new _konva.default.Image({
        image: image,
        draggable: true
      });
      imageRef.current.on("wheel", scrollZoom);
      imageRef.current.on("mouseover", pointer);
      imageRef.current.on("mouseout", cursor);
      imageLayerRef.current.add(imageRef.current);
      imageRef.current.src = src;
    } else if (status === "failed") {
      onError && onError();
    }

    return () => {
      var _stageRef$current;

      stageRef === null || stageRef === void 0 ? void 0 : (_stageRef$current = stageRef.current) === null || _stageRef$current === void 0 ? void 0 : _stageRef$current.destroy();
    };
  }, [status, onLoad, onError]); // set initial scale, or after rotation

  (0, _react.useEffect)(() => {
    if (status === "loaded") {
      setInitialScale();
    }
  }, [status]);
  (0, _react.useEffect)(() => {
    if (containerRef.current) {
      new ResizeObserver(() => {
        if (containerRef.current) {
          photoHandlers.setDimensions({
            height: containerRef.current.offsetHeight,
            width: containerRef.current.offsetWidth
          });
        }
      }).observe(containerRef.current);
    }
  }, [containerRef.current]);

  const setInitialScale = () => {
    if (image && photoState.dimensions.height) {
      const imageHeight = image.height;
      const imageWidth = image.width;
      const newScale = getScale(imageHeight, imageWidth, photoState.dimensions.height, photoState.dimensions.width);
      photoHandlers.setMinZoom(newScale);
      photoHandlers.setZoom(newScale);
    }
  };

  (0, _react.useEffect)(() => {
    if (imageLayerRef.current) {
      imageLayerRef.current.setAttrs({
        scaleX: photoState.zoom,
        scaleY: photoState.zoom
      });
    }
  }, [photoState.zoom, imageLayerRef]);
  return /*#__PURE__*/_react.default.createElement(ImageContainer, {
    ref: containerRef
  }, status !== "loaded" && /*#__PURE__*/_react.default.createElement(ProgressRingContainer, null, /*#__PURE__*/_react.default.createElement(_alloyReactProgressRing.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    id: "container"
  }));
};

var _default = EditableImage;
exports.default = _default;